// tslint:disable:trailing-comma
export var spaConfigRoutes = [
    // Reference Data
    {
        name: 'Reference Data',
        path: '/config/reference-data',
        component: function () { return import('@/pages/reference-data/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'REFERENCEDATA',
        },
    },
    // User Management
    {
        name: 'User Management',
        path: '/config/user-management',
        component: function () { return import('@/pages/user-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'USERMGMT',
        },
    },
    {
        name: 'Manage User',
        path: '/config/user/:id',
        component: function () { return import('@/pages/user-management/AddEditUser.vue'); },
        meta: {
            includeInMenu: false,
            authorize: 'USERMGMT',
        },
    },
    // Carrier Management
    {
        name: 'Carrier Management',
        path: "/config/carrier-management",
        component: function () { return import('@/pages/carrier-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'CARRIERMGMT',
        },
    },
    {
        name: 'Manage Carrier',
        path: '/config/carrier/:id',
        component: function () { return import('@/pages/carrier-management/AddEditCarrier.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'CARRIERMGMT',
        },
    },
    // Carrier Group Management
    {
        name: 'Carrier Group Management',
        path: '/config/carrier-group-management',
        component: function () { return import('@/pages/carrier-management/ManageGroup.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'CARRIERGRPMGMT',
        },
    },
    // Vacation Management
    {
        name: 'Vacation Management',
        path: '/config/vacation-management',
        component: function () { return import('@/pages/vacation-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'VACATIONMGMT',
        },
    },
    // Material Management
    {
        name: 'Material Management',
        path: '/config/material-management',
        component: function () { return import('@/pages/material-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'MATERIALMGMT',
        },
    },
    // Material Group Management
    {
        name: 'Material Group Management',
        path: '/config/material-group-management',
        component: function () { return import('@/pages/material-management/ManageGroup.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'MATERIALGRPMGMT',
        },
    },
    // Material Type Management
    {
        name: 'Material Type Management',
        path: '/config/material-type-management',
        component: function () { return import('@/pages/material-management/ManageType.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'MATERIALTYPEMGMT',
        },
    },
    // Sourcing Material Synonym Management
    {
        name: 'Material Synonym Sourcing Management',
        path: '/config/material-synonym-src-management',
        component: function () { return import('@/pages/material-management/ManageSynSrc.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'MATERIALMGMT#SOURCING',
        },
    },
    // BOL Material Synonym Management
    {
        name: 'Material Synonym Bol Management',
        path: '/config/material-synonym-bol-management',
        component: function () { return import('@/pages/material-management/ManageSynBol.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'MATERIALMGMT#BOL',
        },
    },
    // SAP Material Synonym Management
    {
        name: 'Material Synonym Sap Management',
        path: '/config/material-synonym-sap-management',
        component: function () { return import('@/pages/material-management/ManageSynSap.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'MATERIALMGMT#SAP',
        },
    },
    // Supplier Management
    {
        name: 'Supplier Management',
        path: '/config/supplier-management',
        component: function () { return import('@/pages/supplier-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'SUPPLIERMGMT',
        },
    },
    // Vendor Management
    {
        name: 'Vendor Management',
        path: '/config/vendor-management',
        component: function () { return import('@/pages/vendor-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'VENDORMGMT',
        },
    },
    {
        name: 'Add / Edit Vendor',
        path: '/config/vendor/:id',
        component: function () { return import('@/pages/vendor-management/AddEditVendor.vue'); },
        meta: {
            includeInMenu: false,
            authorize: 'VENDORMGMT',
        },
    },
    {
        name: 'Terminal Name Abbreviations',
        path: '/config/vendor-management/abbreviations/terminals',
        component: function () { return import('@/pages/vendor-management/TerminalNameAbbreviations/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'VENDORMGMT_ABBREVIATIONS#TERMINAL',
        },
    },
    {
        name: 'Supplier Name Abbreviations',
        path: '/config/vendor-management/abbreviations/suppliers',
        component: function () { return import('@/pages/vendor-management/SupplierNameAbbreviations/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'VENDORMGMT_ABBREVIATIONS#SUPPLIER',
        },
    },
    {
        name: 'City Name Abbreviations',
        path: '/config/vendor-management/abbreviations/cities',
        component: function () { return import('@/pages/vendor-management/CityNameAbbreviations/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'VENDORMGMT_ABBREVIATIONS#CITY',
        },
    },
    {
        name: 'TCN Directory',
        path: '/config/vendor-management/tcn-directory',
        component: function () { return import('@/pages/vendor-management/TcnManagement/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            authorize: 'VENDORMGMT_TCN',
        },
    },
    // Opportunity Up Market Load Configuration
    {
        name: 'Opportunity Up Market Load Configuration Management',
        path: '/opportunity/upmarketloadconfiguration',
        component: function () { return import('@/pages/opportunity-management/opportunity-upmarketloadconfig/Index.vue'); },
        meta: {
            includeInMenu: false,
            settings: true,
            authorize: 'OPPORTUNITYUPMARKETCONFIGURATIONS',
        },
    },
    // Contract Management
    // todo update authorize metadata
    {
        name: 'Contract Management',
        path: '/config/contract-management',
        component: function () { return import('@/pages/contract-management/Index.vue'); },
        meta: {
            includeInMenu: true,
            settings: true,
            new: true,
            authorize: 'CONTRACTMGMT',
        },
    },
    {
        name: 'Add / Edit Contract',
        path: '/config/contract/:id',
        component: function () { return import('@/pages/contract-management/AddEditContract.vue'); },
        meta: {
            includeInMenu: false,
            authorize: 'CONTRACTMGMT',
        },
    },
    {
        name: 'Duplicate Contract',
        path: '/config/contract/:id/duplicate',
        component: function () { return import('@/pages/contract-management/AddEditContract.vue'); },
        meta: {
            includeInMenu: false,
            authorize: 'CONTRACTMGMT',
        },
    },
];
